import { DocumentTypesApiResponse, documentTypesApiResponseSchema } from '@repo/shared/domain';
import { constructQuery } from '@repo/shared/helpers';
import { guardedClient as clientRequest } from '@repo/shared/helpers';

export const getDocumentTypes = async (model: string): Promise<DocumentTypesApiResponse> => {
	// pagesize not pageSize
	const query = constructQuery({ model, pagesize: '100' });
	const { body } = await clientRequest.get(`/api/documentTypes?${query}`, {
		schema: documentTypesApiResponseSchema,
	});
	return body;
};

// Document Types
export const getAllDocumentTypes = async (query?: string): Promise<DocumentTypesApiResponse> => {
	const { body } = await clientRequest.get(`/api/documentTypes${query ? `?${query}` : ''}`, {
		schema: documentTypesApiResponseSchema,
	});
	return body;
};

export const getUserDocumentTypes = async (userId: string): Promise<DocumentTypesApiResponse> => {
	return getDocumentTypes('users');
};

export const getGroupDocumentTypes = async (): Promise<DocumentTypesApiResponse> => {
	return getDocumentTypes('groups');
};

export const createDocumentType = async (data: Record<string, unknown>) => {
	return clientRequest.post('/api/documentTypes/', data);
};

export const updateDocumentType = async (id: string, data: Record<string, unknown>) => {
	return clientRequest.put(`/api/documentTypes/${id}`, data);
};
